import { useWorkspaceStore } from '../stores/workspaceStore';
import { useWorkspaces } from './useWorkspace';

/**
 * Resolves where "back to app" / app-home links should go from
 * account-level (non-workspace) pages.
 *
 * Priority:
 *   1. The last workspace the user was actually inside (persisted).
 *   2. The user's first workspace (legacy fallback).
 *   3. '/app' (no workspaces loaded yet) — preserves prior behavior.
 */
export function useLastWorkspace() {
  const lastWorkspaceId = useWorkspaceStore((s) => s.lastWorkspaceId);
  const { data: workspaces } = useWorkspaces();

  const resolvedWorkspaceId = lastWorkspaceId ?? workspaces?.[0]?.id ?? null;
  const appHomePath = resolvedWorkspaceId
    ? `/app/workspace/${resolvedWorkspaceId}/home`
    : '/app';

  return { lastWorkspaceId, resolvedWorkspaceId, appHomePath };
}
